import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const EmptyFlexWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: auto;
  align-self: center;
`;
